import BaseModule from './BaseModule';
import Factory from '../libs/Factory';
import {requireElement} from "../libs/Helpers";

export default class Reveal extends BaseModule {
    private readonly track: HTMLElement;
    private readonly pinSection: HTMLElement;
    private slides: HTMLElement[];

    constructor(el: HTMLDivElement, factory: Factory) {
        super(el, factory, 'Reveal');

        el.querySelectorAll('img').forEach((img) => {
            img.setAttribute('loading', 'eager');
        });

        Promise.all([
            import(/* webpackChunkName: "gsap" */ 'gsap'),
            import(/* webpackChunkName: "gsap" */ 'gsap/ScrollTrigger'),
        ]).then(([gsapModule, ScrollTriggerModule]) => {
            const gsap = gsapModule.gsap;
            gsap.registerPlugin(ScrollTriggerModule.ScrollTrigger);

            const maskLayer = requireElement(el, ".reveal-cover");
            maskLayer.style.clipPath = 'inset(0% 0% 0% 0%)';

            gsap.to(maskLayer, {
                clipPath: 'inset(24% 20% 37%)',
                scrollTrigger: {
                    trigger: el,
                    start: "top top",
                    end: "bottom top",
                    pin: true,
                    scrub: true,
                }
            });
        });
    }
}